import script from "./HrWorkforceBranchesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./HrWorkforceBranchesTab.vue?vue&type=script&setup=true&lang=js"

import "./common/hrWorkforce.css?vue&type=style&index=0&id=ef8f71de&scoped=true&lang=css"
import "./HrWorkforceBranchesTab.vue?vue&type=style&index=1&id=ef8f71de&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef8f71de"]])

export default __exports__